import { Component, inject, OnInit } from '@angular/core';
import { FormBuilder, ReactiveFormsModule } from '@angular/forms';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { MatButton } from '@angular/material/button';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { AccountService } from '../../../services/account.service';
import { SnackbarService } from '../../../services/snackbar.service';
import { environment } from '../../../../environments/environment';
import { MatCardModule } from '@angular/material/card';
import { BusyService } from '../../../services/busy.service';

@Component({
  selector: 'app-login',
  imports: [
    ReactiveFormsModule,
    ReactiveFormsModule,
    MatFormField,
    MatInput,
    MatLabel,
    MatButton,
    MatCardModule,
    RouterLink,
  ],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss',
})
export class LoginComponent implements OnInit {
  private fb = inject(FormBuilder);
  accountService = inject(AccountService);
  private router = inject(Router);
  private snackbar = inject(SnackbarService);
  private route = inject(ActivatedRoute);
  busyService = inject(BusyService);

  production = environment.production;
  height = 0;

  loginForm = this.fb.group({
    username: [''],
    password: [''],
  });

  ngOnInit(): void {
    this.accountService.user$.subscribe((user) => {
      if (user) {
        this.route.queryParams.subscribe((params) => {
          const returnUrl = params['returnUrl'] || '/hours';
          this.router.navigate([returnUrl]);
        });
      }
    });
  }

  onSubmit(): void {
    this.accountService
      .login(this.loginForm.value.username, this.loginForm.value.password)
      .subscribe({
        next: () => {
          this.route.queryParams.subscribe((params) => {
            this.router.navigate(['choose-phone-number'], {
              queryParams: { returnUrl: params['returnUrl'] || '/hours' },
            });
          });
        },
      });
  }
}
